import { Form, Space } from "antd";
import { translate } from "../../../core";
import React, { useState } from "react";
import { InputCard } from "../../inventory/component/InputCard";
import { NumericInput } from "../../../core/component";

export const OrderEntryFooter = ({ onChanged }: { onChanged?: () => void }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <InputCard
      contained
      expandable={true}
      onExpand={() => setIsExpanded(!isExpanded)}
      title={translate("price")}
    >
      {isExpanded && (
        <Space direction="horizontal" size="middle">
          <TotalAmountSection
            name="totalPrice"
            label={translate("total_price")}
            readOnly
          />

          <TotalAmountSection name="tax" label={translate("tax")} readOnly />

          <TotalAmountSection
            name="freight"
            onChanged={onChanged}
            label={translate("freight")}
          />

          <TotalAmountSection
            name="total"
            label={translate("total")}
            readOnly
          />

          <TotalAmountSection
            name="totalPay"
            label={translate("total_payments_abbr")}
            readOnly
          />

          <Form.Item
            shouldUpdate
            label={translate("balance")}
          >
            {({ getFieldValue }) => {
              let value = Number(getFieldValue('balanceDue')) ?? 0
              
              if (value < 0.00 && value >= -0.01)
                value = 0

              return (
                <NumericInput
                  value={value}
                  disabled
                />
              )
            }}
          </Form.Item>
        </Space>
      )}
    </InputCard>
  );
};

const TotalAmountSection = ({
  label,
  name,
  readOnly,
  onChanged,
}: {
  label: React.ReactNode;
  name: string;
  readOnly?: boolean;
  onChanged?: () => void;
}) => (
  <Form.Item name={name} label={label}>
    <NumericInput onChange={onChanged} disabled={readOnly ?? false} />
  </Form.Item>
);
